import { render, staticRenderFns } from "./MaterielsItem.vue?vue&type=template&id=3d8ce46d&"
import script from "./MaterielsItem.vue?vue&type=script&lang=js&"
export * from "./MaterielsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports